import documentsAPI from '../api'

export async function getDocumentTemplates({ page, limit }) {
	const { data } = await documentsAPI.get(
		`/templates/?per_page=${limit}&page=${page}`
	)

	return data
}

export async function getDocumentsByStatus() {
	const { data } = await documentsAPI.get(`/workflow/documents-by-status`)

	return data
}
